import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { spacing, breakpoints } from 'styles/globals';
import TopicCard from 'components/TopicCard';
import { TOPIC_CARD } from 'utils/image/getPictureUrl';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
var TopicGridItem = styled.li.attrs({
  role: 'listitem'
}).withConfig({
  displayName: "TopicList__TopicGridItem",
  componentId: "sc-30qcyf-0"
})(["display:flex;flex-shrink:0;align-items:flex-start;width:50%;@media (min-width:", "){width:25%;}@media (min-width:", "){width:20%;}@media (min-width:", "){width:16.666%;}"], breakpoints.xxs, breakpoints.s, breakpoints.m);
var TopicGrid = styled.ul.attrs({
  role: 'list'
}).withConfig({
  displayName: "TopicList__TopicGrid",
  componentId: "sc-30qcyf-1"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}@media (min-width:", "){margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}}"], spacing.s, spacing.xs, TopicGridItem, spacing.s, spacing.xs, breakpoints.s, spacing.m, spacing.s, TopicGridItem, spacing.m, spacing.s);
function TopicList(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'tiles' : _ref$variant,
    _ref$withBrowseButton = _ref.withBrowseButton,
    withBrowseButton = _ref$withBrowseButton === void 0 ? false : _ref$withBrowseButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (items.length === 0) {
    return null;
  }
  if (variant === 'buttons') {
    return /*#__PURE__*/React.createElement(InlineList, {
      spacing: "s"
    }, items.map(function (topic) {
      return /*#__PURE__*/React.createElement(Button, {
        key: topic.id,
        as: NavLink,
        to: "/browse/".concat(topic.id),
        variant: "shaded"
      }, topic.name);
    }), withBrowseButton && /*#__PURE__*/React.createElement(Button, {
      round: true,
      variant: "shaded",
      iconRight: "arrow-right",
      as: NavLink,
      to: "/browse"
    }, t('actions_browse_all_playlists')));
  }
  return /*#__PURE__*/React.createElement(TopicGrid, null, items.map(function (topic) {
    return /*#__PURE__*/React.createElement(TopicGridItem, {
      key: topic.id
    }, /*#__PURE__*/React.createElement(TopicCard, {
      as: NavLink,
      to: "/browse/".concat(topic.id),
      id: "filter_".concat(topic.name),
      icon: "topic",
      imageSrc: topic.pictureUrl && "".concat(topic.pictureUrl, "/").concat(TOPIC_CARD)
    }, topic.name));
  }), withBrowseButton && /*#__PURE__*/React.createElement(TopicGridItem, {
    key: "browse-all"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    as: NavLink,
    to: "/browse",
    align: "left",
    variant: "shaded",
    iconRight: "arrow-right",
    size: "large",
    mt: 26
  }, t('actions_browse_all_playlists'))));
}
export default TopicList;